import { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";

const TARGET = "/p/dashboard/organized-tours/results";

export default function TourResultsLegacyDashboardRedirect() {
  const navigate = useNavigate();
  useLayoutEffect(() => {
    navigate(TARGET, { replace: true });
  }, [navigate]);
  return null;
}
